import { BaseLivlyApiResponse } from "@/types/Base";
import axios from "axios";
import { BASE_API_URL } from "./constants";
import { AUTHORIZATION_HEADER_KEY } from "./localStorage";
import { User } from "@/types/User";

export async function getUser(leaseId: string, accessToken: string) {
  const result = await axios.get<BaseLivlyApiResponse<User>>(
    `${BASE_API_URL}/livly/users/me?v=202404&leaseId=${leaseId}`,
    { headers: { [AUTHORIZATION_HEADER_KEY]: `Bearer ${accessToken}` } }
  );

  return result.data.Data;
}
